import Vue from 'vue'
import Vuex from 'vuex'
import Blog from "@/store/modules/blog";
import Auth from "@/store/modules/auth";
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        Blog,
        Auth
    }
})
